/**
 * training-handler.js
 */

import { Types } from 'utils/constants';


export default function TrainingHandler() {
  const type = Types.RecordGroup.TRAINING;


  /**
   * retreives record index based on provided type
   */
  const recordIndex = (type, state) => {
    const map = {
      [Types.Record.EVENT]: state.training.event,
      [Types.Record.EXERCISE]: state.training.exercise,
      [Types.Record.ANSWER]: state.training.answer
    };
    return map[type];
  }


  const recordRoute = (type, id) => {
    const map = {
      [Types.Record.EVENT]: `/training/event/${id}`,
      [Types.Record.EXERCISE]: `/training/exercise/${id}`,
      [Types.Record.ANSWER]: `/training/answer/${id}`,
    };
    return map[type];
  }


  const processRecord = (record, updateDateIndex, state, user) => {
    let listRecords = [];

    if (record.recordType === Types.Record.EVENT) {
      processEvent(record, updateDateIndex, state, user);
      listRecords.push(record);
    } else if (record.recordType === Types.Record.EXERCISE) {
      processExercise(record, state, user);
    } else if (record.recordType === Types.Record.ANSWER) {
      processAnswer(record, state);
    }   

    return listRecords;
  }


  const processEvent = (record, updateDateIndex, state, user) => {
    const eventRecord = updateEventIndex(record, state);

    if (updateDateIndex) {
      updateDateIndex(eventRecord, state);
    }

    if (record.exercises) {
      record.exercises.forEach(exercise => {
        processExercise(exercise, state, user);
      })
    }
  }


  const processExercise = (record, state, user) => {
    updateExerciseIndex(record, state, user);
    record.answers && record.answers.forEach(answer => {
      processAnswer(answer, state);
    });
  }


  const processAnswer = (record, state) => {
    updateAnswerIndex(record, state);
  }


  const updateEventIndex = (event, state) => {
    const eventItem = {
      ...event,
      eventId: event.id,
      exercises: event.exercises
        ? event.exercises.map(exercise => exercise.id)
        : []
    }
    if (eventItem.id !== undefined) {
      recordIndex(Types.Record.EVENT, state)[eventItem.id].merge(eventItem);
    }
    return eventItem;
  }


  // answers list structure differs between handler & supervisor.
  const updateExerciseIndex = (exercise, state, user) => {
    let answers = [];

    // NO ANSWERS
    if (!exercise.answers) {
      answers = [];
    } 
    // NEW EXERCISE
    else if (exercise.id === 0) {
      answers = exercise.answers;
    } 
    // DEFAULT
    else {
      answers = exercise.answers.map(answer => answer.id);
    }
      

    const exerciseItem = { ...exercise, answers };
    recordIndex(Types.Record.EXERCISE, state)[exerciseItem.id].merge(exerciseItem);
    return exerciseItem;
  }


  const updateAnswerIndex = (answer, state) => {
    const answerItem = {...answer};
    recordIndex(Types.Record.ANSWER, state)[answer.id].merge(answerItem);
    return answerItem;
  }
  

  // public interface
  return ({
    type,
    recordIndex,
    recordRoute,
    processRecord,
  });
}